import React from 'react';
import PropTypes from 'prop-types';
import CheckContent from '../../../CheckContent';
import FormGroup from '../../../FormGroup';
import ExchangeRates from '../../../ExchangeRates';

class ConversionItemContent extends React.Component {
    constructor(props) {
        super();

        this.state = {
            isEmpty: props.isEmpty,
            data: props.data,
            loading: true
        };
    }

    componentDidMount() {
        this.props.getConversion(this.props.params.id);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isEmpty !== this.props.isEmpty || 
            prevProps.data !== this.props.data || 
            prevProps.loading !== this.props.loading) {
            this.setState({
                isEmpty: this.props.isEmpty,
                data: this.props.data,
                loading: this.props.loading
            });
        }
    }

    render() {
        const staticNames = this.context.t?.conversionItemPage || {};
        const staticNameLabels = this.context.t?.dataTable?.headers || {};
        const commonKeys = Object.keys(this.state.data.common || {});
        const commissionKeys = Object.keys(this.state.data.commission || {});
        const goalKeys = Object.keys(this.state.data.goal || {});
        const trackKeys = Object.keys(this.state.data.track || {});
        const paramsKeys = Object.keys(this.state.data.params || {});

        return (
            <CheckContent
                loading={this.state.loading}
                isEmpty={this.state.isEmpty}
            >
                <div className="row ibox-list-holder">
                    <div className="col-sm-12 col-md-6 ibox-column-holder">
                        <div className="ibox">
                            <div className="ibox-content field-list-holder">
                                <div className="ibox-title">
                                    <h5>{staticNames.generalInfo}</h5>
                                </div>
                                <div className="form-horizontal form-horizontal_flex">
                                    {commonKeys.map((key) => (
                                        <FormGroup
                                            key={key}
                                            label={`${staticNameLabels[key]}:`}
                                            labelClass={''}
                                            fieldClass={''}
                                        >{this.state.data.common[key]}</FormGroup>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="ibox">
                            <div className="ibox-content field-list-holder">
                                <div className="ibox-title">
                                    <h5>{staticNames.goal}</h5>
                                </div>
                                <div className="form-horizontal form-horizontal_flex">
                                    {goalKeys.map((key) => (
                                        <FormGroup
                                            key={key}
                                            label={`${staticNameLabels[key]}:`}
                                            labelClass={''}
                                            fieldClass={''}
                                        >{this.state.data.goal[key]}</FormGroup>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="ibox">
                            <div className="ibox-content field-list-holder">
                                <div className="ibox-title">
                                    <h5>{staticNames.options}</h5>
                                </div>
                                <div className="form-horizontal form-horizontal_flex">
                                    {paramsKeys.map((key) => (
                                        <FormGroup
                                            key={key}
                                            label={`${key}:`}
                                            labelClass={''}
                                            fieldClass={''}
                                        >{this.state.data.params[key]}</FormGroup>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 ibox-column-holder">
                        <div className="ibox">
                            <div className="ibox-content field-list-holder">
                                <div className="ibox-title">
                                    <h5>{staticNames.commission}</h5>
                                </div>
                                <div className="form-horizontal form-horizontal_flex">
                                    {commissionKeys.map((key) => (
                                        <FormGroup
                                            key={key}
                                            label={`${staticNameLabels[key]}:`}
                                            labelClass={''}
                                            fieldClass={''}
                                        >{this.state.data.commission[key]}</FormGroup>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <ExchangeRates
                            data={this.state.data.currency}
                            formGroupLabelClass={''}
                            formGroupFieldClass={''}
                        />
                        <div className="ibox">
                            <div className="ibox-content field-list-holder">
                                <div className="ibox-title">
                                    <h5>{staticNames.track}</h5>
                                </div>
                                <div className="form-horizontal form-horizontal_flex">
                                    {trackKeys.map((key) => (
                                        <FormGroup
                                            key={key}
                                            label={`${staticNameLabels[key]}:`}
                                            labelClass={''}
                                            fieldClass={''}
                                        >{this.state.data.track[key]}</FormGroup>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CheckContent>
        );
    }
}

ConversionItemContent.contextTypes = {
    t: PropTypes.object
};

ConversionItemContent.propTypes = {
    isEmpty: PropTypes.bool,
    data: PropTypes.shape({
        common: PropTypes.object,
        commission: PropTypes.object,
        params: PropTypes.object,
        track: PropTypes.object,
        currency: PropTypes.object,
        goal: PropTypes.object
    }),
    loading: PropTypes.bool,
    params: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    getConversion: PropTypes.func
};

ConversionItemContent.defaultProps = {
    isEmpty: false,
    data: {
        common: {},
        commission: {},
        params: {},
        track: {},
        currency: {},
        goal: {}
    },
    loading: false,
    params: {},
    getConversion: () => {}
};

export default ConversionItemContent;
